import { render, staticRenderFns } from "./GroupTreatment.vue?vue&type=template&id=7ef16b11"
import script from "./GroupTreatment.vue?vue&type=script&lang=ts"
export * from "./GroupTreatment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports